/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Equipment_WhichInputs */

const en_us2_workout_after_equipment_which = /** @type {(inputs: Workout_After_Equipment_WhichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which was missing?`)
};

const pt_br2_workout_after_equipment_which = /** @type {(inputs: Workout_After_Equipment_WhichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual faltou?`)
};

const es_419_workout_after_equipment_which = /** @type {(inputs: Workout_After_Equipment_WhichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál faltó?`)
};

const pt_pt2_workout_after_equipment_which = /** @type {(inputs: Workout_After_Equipment_WhichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual faltou?`)
};

const fr_fr2_workout_after_equipment_which = /** @type {(inputs: Workout_After_Equipment_WhichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lequel manquait ?`)
};

const de_de2_workout_after_equipment_which = /** @type {(inputs: Workout_After_Equipment_WhichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was hat gefehlt?`)
};

const it_it2_workout_after_equipment_which = /** @type {(inputs: Workout_After_Equipment_WhichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale mancava?`)
};

/**
* | output |
* | --- |
* | "Which was missing?" |
*
* @param {Workout_After_Equipment_WhichInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_equipment_which = /** @type {((inputs?: Workout_After_Equipment_WhichInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Equipment_WhichInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_equipment_which(inputs)
	if (locale === "es-419") return es_419_workout_after_equipment_which(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_equipment_which(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_equipment_which(inputs)
	if (locale === "de-DE") return de_de2_workout_after_equipment_which(inputs)
	if (locale === "it-IT") return it_it2_workout_after_equipment_which(inputs)
	return en_us2_workout_after_equipment_which(inputs)
});
export { workout_after_equipment_which as "workout-after.equipment_which" }